<template>
  <div :key="payload.id" style="white-space: pre-line;">
    <p>{{ payload.title || payload.designator }}</p>
    <br />
    <br />
    <component v-if="component.length > 0" :is="component" :payload="component_payload" @input="passData"></component>
    <p v-else v-html="$sanitize(regular_text)"></p>
  </div>
</template>
<script>
import AlertButton from '@/components/AlertButton'
import AlertOffersContent from '@/components/AlertOffersContent'
import PositionOffersReport from '@/components/PositionOffersReport'
import PassValidator from '@/components/PassValidator'
import AlertContentSendCv from '@/components/AlertContentSendCv'
import StargateSetupContent from '@/components/StargateSetupContent'
import FollowUpCompaniesContent from '@/components/FollowUpCompaniesContent'
import PositionGhanaFlag from '@/components/PositionGhanaFlag'
import ActivateCompanyEmployee from '@/components/ActivateCompanyEmployee'
import ContentField from '@/components/ContentField'
import AlertVettedOffer from '@/components/AlertVettedOffer'
import NewLeadText from '@/components/NewLeadText'
import FeedContentMorningRoutine from '@/components/FeedContentMorningRoutine'
import FeedContentReviewPosition from '@/components/FeedContentReviewPosition'

export default {
  name: 'alert-content',
  components: {
    AlertButton,
    AlertOffersContent,
    PositionOffersReport,
    PassValidator,
    AlertContentSendCv,
    StargateSetupContent,
    FollowUpCompaniesContent,
    ActivateCompanyEmployee,
    PositionGhanaFlag,
    ContentField,
    NewLeadText,
    FeedContentReviewPosition,
    AlertVettedOffer,
    FeedContentMorningRoutine
  },
  props: ['payload'],
  data () {
    return {
      regular_text: this.payload.content,
      component: '',
      component_payload: {},
      json_content: undefined
    }
  },
  created () {
    this.init()
  },
  watch: {
    payload () {
      this.init()
    }
  },
  methods: {
    passData (d) {
      this.$emit('input', d)
    },
    init () {
      let content = this.payload.content
      let designator = this.payload.designator
      if (designator == 'send_cv' && this.payload.resources != undefined) {
        this.setSendCVContent()
        return
      }
      if (['applicant_registered', 'stargate_setup'].includes(designator)) {
        this.setStargateSetupContent()
        return
      }
      if (designator == 'follow_up_companies') {
        this.setFollowUpCompaniesContent()
        return
      }
      if (designator == 'vetted_offers') {
        this.setVettedOffersContent()
        return
      }
      if (designator == 'company_response') {
        this.setCompanyResponseContent()
        return
      }
      if (designator == 'company_employee_created') {
        this.setCompanyEmployeeCreatedContent()
        return
      }
      if (designator == 'spring_project') {
        this.setSpringProjectContent()
        return
      }
      if (['missions', 'designated_position', 'strong_offers'].includes(designator)) {
        this.setMissionContent()
        return
      }
      if (['review_position', 'notice_position'].includes(designator)) {
        this.setComponent('FeedContentReviewPosition', this.payload)
        return
      }
      if (designator == 'morning_routine') {
        this.setMorningRoutineContent()
        return
      }
      if (designator == 'new_lead') {
        this.setNewLeadContent()
        return
      }
      if (content != undefined && this.$utils.isStringJSON(content)) {
        this.jsonizeContent()
      }
    },
    setComponent (component, payload) {
      this.component = component
      this.component_payload = payload
    },
    setFollowUpCompaniesContent () {
      this.component = 'FollowUpCompaniesContent'
      this.component_payload = this.payload
    },
    setCompanyResponseContent () {
      let jsonized_content = JSON.parse(this.payload.json_data)
      let old_status = jsonized_content.old_status != undefined ? ', Old Status: ' + jsonized_content.old_status : ''
      this.regular_text = 'New Status: ' + jsonized_content.new_status + ', Reason: ' + jsonized_content.rejected_reason + old_status
    },
    setStargateSetupContent () {
      this.component = 'StargateSetupContent'
      this.component_payload = this.payload.resources.applicant
    },
    setSendCVContent () {
      this.component = 'AlertContentSendCv'
      this.component_payload = this.payload
    },
    setVettedOffersContent () {
      this.component = 'AlertVettedOffer'
      this.component_payload = this.payload
    },
    setCompanyEmployeeCreatedContent () {
      this.component = 'ActivateCompanyEmployee'
      this.component_payload = this.payload
    },
    setMorningRoutineContent () {
      this.component = 'FeedContentMorningRoutine'
      this.component_payload = this.payload
    },
    setNewLeadContent () {
      this.component = 'NewLeadText'
      this.component_payload = this.payload.content
    },
    setMissionContent () {
      if (this.payload.resource_type == 'Position') {
        this.component = 'PositionGhanaFlag'
        this.component_payload = this.payload
        return
      }
      if (this.payload.resource_type == 'Offer') {
        this.component = 'AlertOffersContent'
        this.component_payload = this.payload
        return
      }
      this.component = 'ContentField'
      this.component_payload = this.payload
    },
    setSpringProjectContent () {
      let applicant_tags = this.payload.resources.applicant.tags
      this.regular_text = (applicant_tags == undefined || applicant_tags.length == 0) ? 'NO TAGS' : applicant_tags
    },
    jsonizeContent () {
      let parsed_content = JSON.parse(this.payload.content)
      let designator = this.payload.designator
      if (designator == 'position_offers_report') {
        this.component = 'PositionOffersReport'
        this.component_payload = { resource: this.payload.resources.position, ...parsed_content }
        return
      }
      if (['applicant_creation_failed', 'position_creation_failed'].includes(designator)) {
        this.component = 'PassValidator'
        this.component_payload = parsed_content
      }
    }
  }
}
</script>
